// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"be55fc82b7124b54753b","224":"184384767082f8e91141"}[chunkId] + ".js";
};